import styled from '@emotion/styled';

import { MEDIA_QUERY, SPACING } from '../../../../../styles/emotion';

import { CheckboxFieldAdapter } from '../../../../Form/CheckboxField';
import FormDatePickerV2 from '../../../../Form/DatePickerInputV2/FinalFormDatePickerV2';
import { StyledDayPicker } from '../../../../Form/DatePickerInputV2/DatePickerInputV2/DatePickerInputV2.styles';
import { InputFieldContainer } from '../../../../Form/inputV3/InputFieldV3/InputFieldV3.styles';

export const SkipDateCheckbox = styled(CheckboxFieldAdapter)`
  align-self: start;
  ${MEDIA_QUERY.EXCLUDE_MOBILE} {
    margin-top: ${SPACING.LG};
  }
`;

export const StyledFormDatePicker = styled(FormDatePickerV2)`
  ${StyledDayPicker} {
    bottom: 53px;
    & .DayPicker {
      min-height: 322px; // this keeps the height consistent between months with 5 rows vs 6 rows
    }
  }
  ${InputFieldContainer}[data-state="error"] {
    ${StyledDayPicker} {
      bottom: 74px;
    }
  }
  ${MEDIA_QUERY.DESKTOP} {
    ${StyledDayPicker} {
      bottom: 54px;
    }
    ${InputFieldContainer}[data-state="error"] {
      ${StyledDayPicker} {
        bottom: 70px;
      }
    }
  }
`;
